import axios, { AxiosResponse } from 'axios';

import { FEATURE_FLAGS_BASE_URL } from '@/constants/ecomm/ecommBaseUrls';
import getEnv from '@/utils/environment';

export const getFeatureFlags = async () => {
  const env = getEnv();
  const featureFlagResponse: AxiosResponse = await axios.get(
    FEATURE_FLAGS_BASE_URL[env]
  );
  return featureFlagResponse.data;
};
